import { type IMessageActionData } from 'entities/TemplateActions/actions.tsx'
import { type AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { callingAgentSendSMS } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/actions/sendSMS/callingAgentSendSMS.tsx'

export const onSendSMSChipClick =
  (store: AgentInstructionsStore) => (chip: HTMLSpanElement, data: IMessageActionData) => {
    const { getAgentAction, onUpdateAgentAction, deleteChipAndAgentAction } = store
    if ('token_id' in data) {
      const token_id = data.token_id
      if (token_id) {
        const action = getAgentAction(token_id)
        if (action?.action_type === 'send_message') {
          callingAgentSendSMS({
            onSave: onUpdateAgentAction,
            action,
            onDelete: () => deleteChipAndAgentAction(chip, action),
          })
        }
      }
    }
  }
